import { render } from "./StatisticVendeurs.vue?vue&type=template&id=558df20c"
import script from "./StatisticVendeurs.vue?vue&type=script&lang=js"
export * from "./StatisticVendeurs.vue?vue&type=script&lang=js"

import "./StatisticVendeurs.vue?vue&type=style&index=0&id=558df20c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__